import script from "./HrNotificationModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./HrNotificationModal.vue?vue&type=script&lang=ts&setup=true"

import "./HrNotificationModal.vue?vue&type=style&index=0&id=6caf82f4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6caf82f4"]])

export default __exports__